import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { FilterSearchingProgramaVerificacionViewModel, ProgramaVerificacionItemResultsViewModel } from './buscador-pvcam.types';
import { ProgramaVerificacionViewModel } from '../../programasverificacion/datosbasicos/pvcam-datosbasicos.types';

///https://angular.io/tutorial/toh-pt6
//https://malcoded.com/posts/angular-backend-asp-core

@Injectable()
export class BuscadorProgramaVerificacionService {
    constructor(
        private http: HttpClient,
        @Inject('BASE_URL') private baseUrl: string,
    ) {}

    private endpoint = this.baseUrl + 'api/campanias/programaverificacion/';
    private lastSearch?: FilterSearchingProgramaVerificacionViewModel;

    /**
     * Invokes the service to get the list of "Programa Verificacion", applying the filter in the parameter
     * @param payload FilterSearchingPeriodoCamViewModel
     * @returns Observable<ProgramaVerificacionItemResultsViewModel>
     */
    getList(payload: FilterSearchingProgramaVerificacionViewModel): Observable<ProgramaVerificacionItemResultsViewModel> {
        this.lastSearch = payload; // Keep for future search
        //const params = this.convertModelToHttpParms(payload);
        return this.postPagedByFilter(payload);
    }

    /**
     * Invokes the service to get the list of "Programa Verificacion", applying the filter in the parameter
     * @param params HttpParams
     * @returns Observable<ProgramaVerificacionItemResultsViewModel>
     */
    private postPagedByFilter(payload: FilterSearchingProgramaVerificacionViewModel): Observable<ProgramaVerificacionItemResultsViewModel> {
        return this.http.post<ProgramaVerificacionItemResultsViewModel>(this.endpoint + 'PostPagedByFilter/', payload);
    }

    export(model: FilterSearchingProgramaVerificacionViewModel): Observable<HttpResponse<Blob>> {
        return this.http.post(this.endpoint + 'PostExportExcelByFilter', model, { observe: 'response', responseType: 'blob' });
    }

    getLastSearch(): FilterSearchingProgramaVerificacionViewModel | undefined {
        return this.lastSearch;
    }

    clearLastSearch(): void {
        this.lastSearch = undefined;
    }

    getById(id: number): Observable<ProgramaVerificacionViewModel> {
        return this.http.get<ProgramaVerificacionViewModel>(this.endpoint + id);
    }
}
